import axios from "axios";
import { backend } from "../config/backend";

const API = axios.create({ baseURL: backend.urlEndPoint });

API.interceptors.request.use((req) => {
	if (localStorage.getItem("profile")) {
		req.headers.authorization = `Bearer ${localStorage.getItem("profile").token}`;
	}
	return req;
});

export const agentRequestTransfer = async (token, cryptoCurrency, network, agent, amount, currency, maxSet) => {
	return await API.post(
		"/admin/withdrawal/agentrequesttransfer",
		{
			token,
			cryptoCurrency,
			network,
			agent,
			amount,
			currency,
			maxSet,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getTransfers = async (token, id) => {
	return await API.post(
		"/admin/transfers/gettransfers",
		{
			token,
			id,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};
